import { TRootState } from "Redux/Reducers";

export const getLastLocationId = (state: TRootState) => state.location.lastUpdateId;
